import React, { HTMLProps } from 'react';
import moment from 'moment';
import { DeadlineDate } from 'src/components/PortalList/PortalDeadlineDate';

interface Props extends HTMLProps<HTMLElement> {
  date: string;
}

const MandateDate = ({ date, ...props }: Props) => {
  const momentDate = moment(date);
  return momentDate.isValid() ? (
    <DeadlineDate {...props} date={momentDate.format('L')} />
  ) : (
    <span {...props}>{date || '-'}</span>
  );
};

export default MandateDate;
